// extracted by mini-css-extract-plugin
export default {"item-list":"SaladsDesktop_item-list__Z+H1t","item":"SaladsDesktop_item__S4kkY","category-title":"SaladsDesktop_category-title__oHkex"};